import React, { memo, FunctionComponent, useState, useCallback, useEffect } from 'react';

import { consignerMenu, operatorMenu } from './Menu.constants';
import MenuItem, { Item } from './MenuItem';
import Accordion from '../Accordion';
import MenuIcon from './MenuIcon';
import { logout } from '../../utils/apiConfig';

import './Menu.scss';

interface ItemList {
  name: string;
  link?: string;
  location?: string;
  iconName: string;
  isExpandable?: boolean;
  list?: Array<Item>;
  type?: string;
  isOldLink?: boolean;
  tag?: string;
}

const MenuList: FunctionComponent<{ location: string; type: string }> = memo(({ location, type }) => {
  const [openExpandable, setOpenExpandable] = useState<string | null>(null);
  const [itemList, setItemList] = useState<Array<any>>([]);

  const onToggleClick = useCallback((name: string) => {
    setOpenExpandable((prev) => (prev === name ? null : name));
  }, []);

  const returnToggleOpenOption = (name: string) => openExpandable === name;

  useEffect(() => {
    if (type === 'CONSIGNER') {
      setItemList(consignerMenu);
    } else setItemList(operatorMenu);
  }, [type]);

  return (
    <div>
      {itemList &&
        itemList.map((item: ItemList) => {
          if (!item.isExpandable) {
            return <MenuItem {...item} location={location} key={item.name} />;
          } else {
            return (
              <div className="menu-item-wrapper" key={item.name}>
                <div className="item-image-wrapper">
                  <MenuIcon
                    name={item.iconName}
                    path={returnToggleOpenOption(item.name) ? 'menu/active' : 'menu/inactive'}
                    type={item.type}
                  />
                </div>
                <Accordion
                  title={item.name}
                  key={item.name}
                  clickHandler={onToggleClick}
                  open={returnToggleOpenOption(item.name)}
                >
                  {item.list &&
                    item.list.map((childItem) => (
                      <MenuItem key={childItem.name} {...childItem} location={location} />
                    ))}
                </Accordion>
              </div>
            );
          }
        })}

      <div className="menu-item-wrapper" onClick={logout}>
        <MenuIcon type="svg" name="logout" path="menu" />
        <div className="name">Log Out</div>
      </div>
    </div>
  );
});

export default MenuList;
